import React from 'react';
import { Hero } from '../components/Hero';
import { Ethos } from '../components/Ethos';
import { Palette } from '../components/Palette';
import { Collection } from '../components/Collection';
import { Materials } from '../components/Materials';
import { Atelier } from '../components/Atelier';
import { Newsletter } from '../components/Newsletter';
export function Home() {
  return <>
      <Hero data-id="element-212" data-mp="1zi7e8b3wrg9t" />
      <Ethos data-id="element-213" data-mp="1ziqulndwtwlq" />
      <Palette data-id="element-214" data-mp="1ziz558mk8ptr" />
      <Collection data-id="element-215" data-mp="1zjifo49vsbxr" />
      <Materials data-id="element-216" data-mp="1zk1uhc48ik7k" />
      <Atelier data-id="element-217" data-mp="24h0n1q892j3n" />
      <Newsletter data-id="element-218" data-mp="24gilqf6qdeov" />
    </>;
}